import React from 'react';

const Compliance = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Compliance & Regulatory Information</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #2563eb'}}>
              <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Our Compliance Commitment</h2>
              <p>
                MEES HOLDINGS INC is committed to maintaining the highest standards of compliance with all applicable 
                federal and state regulations governing SMS marketing and telecommunications. As an authorized reseller 
                of SMS services, we work with compliant providers and ensure that all client campaigns adhere to industry 
                best practices and legal requirements. We are currently preparing for A2P registration to ensure full 
                carrier compliance.
              </p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>TCPA Compliance</h2>
            <p style={{marginBottom: '1rem'}}>
              We strictly adhere to the Telephone Consumer Protection Act (TCPA) requirements:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Prior express written consent required for all marketing messages</li>
              <li>Clear and conspicuous disclosure of message frequency and charges</li>
              <li>Easy opt-out mechanisms (STOP, UNSUBSCRIBE)</li>
              <li>Proper record-keeping of all consent and opt-out requests</li>
              <li>Compliance with calling time restrictions</li>
              <li>Regular consent verification and validation</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>CAN-SPAM Act Compliance</h2>
            <p style={{marginBottom: '1rem'}}>
              All our SMS campaigns comply with CAN-SPAM Act requirements:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Truthful and non-deceptive header information</li>
              <li>Non-deceptive subject lines</li>
              <li>Clear identification of messages as advertisements</li>
              <li>Valid physical postal address disclosure</li>
              <li>Clear and conspicuous opt-out mechanisms</li>
              <li>Prompt processing of opt-out requests</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>A2P Registration & Carrier Compliance</h2>
            <p style={{marginBottom: '1rem'}}>
              MEES HOLDINGS INC is preparing for Application-to-Person (A2P) registration and maintains compliance readiness:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Preparing for registration with The Campaign Registry (TCR)</li>
              <li>Business verification documentation ready for brand registration</li>
              <li>Understanding and following carrier-specific requirements</li>
              <li>Monitoring carrier policy updates and guidelines</li>
              <li>Partnering with compliant SMS service providers</li>
              <li>Following proper message classification and content guidelines</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Data Protection & Privacy</h2>
            <p style={{marginBottom: '1rem'}}>
              We implement comprehensive data protection measures:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Encryption of all customer data in transit and at rest</li>
              <li>Secure data storage and access controls</li>
              <li>Regular security audits and vulnerability assessments</li>
              <li>GDPR compliance for international customers</li>
              <li>Data retention and deletion policies</li>
              <li>Employee training on data protection practices</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Industry Certifications</h2>
            <div className="compliance-badges" style={{justifyContent: 'flex-start', gap: '1rem'}}>
              <div className="badge">
                <h4>TCPA Compliant</h4>
                <p>Following all TCPA regulations</p>
              </div>
              <div className="badge">
                <h4>A2P Preparation</h4>
                <p>Ready for carrier registration</p>
              </div>
              <div className="badge">
                <h4>Trusted Partners</h4>
                <p>Working with approved providers</p>
              </div>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Compliance Monitoring</h2>
            <p style={{marginBottom: '2rem'}}>
              Our compliance program includes continuous monitoring and regular audits to ensure ongoing adherence 
              to all applicable regulations. We maintain detailed records of all campaigns, consent mechanisms, 
              and opt-out requests as required by law.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Client Responsibilities</h2>
            <p style={{marginBottom: '1rem'}}>
              While we provide compliant infrastructure and services, our clients are responsible for:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Obtaining proper consent before providing contact information</li>
              <li>Providing accurate and truthful message content</li>
              <li>Maintaining records of customer consent</li>
              <li>Honoring opt-out requests promptly</li>
              <li>Following industry best practices for customer communications</li>
              <li>Ensuring compliance with industry-specific regulations applicable to their business</li>
            </ul>

            <div style={{background: '#fef2f2', padding: '2rem', borderRadius: '10px', border: '2px solid #ef4444'}}>
              <h3 style={{color: '#ef4444', marginBottom: '1rem'}}>Important Notice</h3>
              <p>
                This compliance information is provided for general guidance only and does not constitute legal advice. 
                Clients should consult with qualified legal counsel to ensure their specific use cases comply with all 
                applicable laws and regulations.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Compliance;